import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  _setModality,
  _setCommunityBasedProvider,
  _setBudgetType,
  _setAuthType,
  _setFundingOrg,
  _setTransferForm,
  _setInitialReferral,
  _setAthIssueDate,
  _setExt1IssueDate,
  _setExt2IssueDate,
  _setAuthorizedByOriginal,
  _setAuthorizedByExtension1,
  _setAuthorizedByExtension2,
  //_setDaysAuthorisedStartDate,
  _setExt1StartDate,
  _setExt2StartDate,
  _setDaysAuthorisedQty,
  _setExt1DayQty,
  _setExt2DayQty,
  _setDaysAuthorisedDayDelay,
  //_setDaysAuthorisedEndDate,
  _setExt1EndDate,
  _setExt2EndDate,
  _setOverAllStartDate,
  _setOverallQty,
  _setOverAllEndDate,
  _setUnitsTotal,
  _setMaxUnitsPerWeek,
  _setMaxIndsPerWeek,
  _setMaxGrpsPerWeek,
  _setCbpAdmitDate,
  _setCbpDischargeDate,
  _setAuthStartDate,
  _setAuthEndDate,
  _setPlacementType,
  _setRelapse,
  _setAuthComment,
  _setCompletionSurveyAdministered,
  _setAuthIsLocked,
  _setAdministrativeTransferAdmit,
  _setAuthorizationReviewedBy,
  _setReviewDate,
  _setAthTPRcd,
  _setAth1502Rcd
} from './authFormActions';
import initialState from './authInitialState';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getAuthForm = createAsyncThunk(
  'stop/getAuthForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        //console.log('######################## GET AUTH FORM')
        //console.log(response)
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const authFormSlice = createSlice({
  name: 'stop/authForm',
  initialState,
  reducers: {
    newAuthForm: (state, action) => action.payload,
    setModality: _setModality,
    setCommunityBasedProvider: _setCommunityBasedProvider,
    setBudgetType: _setBudgetType,
    setAuthType: _setAuthType,
    setFundingOrg: _setFundingOrg,
    setTransferForm: _setTransferForm,
    setInitialReferral: _setInitialReferral,
    setAthIssueDate: _setAthIssueDate,
    setExt1IssueDate: _setExt1IssueDate,
    setExt2IssueDate: _setExt2IssueDate,
    setAuthorizedByOriginal: _setAuthorizedByOriginal,
    setAuthorizedByExtension1: _setAuthorizedByExtension1,
    setAuthorizedByExtension2: _setAuthorizedByExtension2,
    //setDaysAuthorisedStartDate: _setDaysAuthorisedStartDate,
    setExt1StartDate: _setExt1StartDate,
    setExt2StartDate: _setExt2StartDate,
    setDaysAuthorisedQty: _setDaysAuthorisedQty,
    setExt1DayQty: _setExt1DayQty,
    setExt2DayQty: _setExt2DayQty,
    setDaysAuthorisedDayDelay: _setDaysAuthorisedDayDelay,
    //setDaysAuthorisedEndDate: _setDaysAuthorisedEndDate,
    setExt1EndDate: _setExt1EndDate,
    setExt2EndDate: _setExt2EndDate,
    setOverAllStartDate: _setOverAllStartDate,
    setOverallQty: _setOverallQty,
    setOverAllEndDate: _setOverAllEndDate,
    setUnitsTotal: _setUnitsTotal,
    setMaxUnitsPerWeek: _setMaxUnitsPerWeek,
    setMaxIndsPerWeek: _setMaxIndsPerWeek,
    setMaxGrpsPerWeek: _setMaxGrpsPerWeek,
    setCbpAdmitDate: _setCbpAdmitDate,
    setCbpDischargeDate: _setCbpDischargeDate,
    setAuthStartDate: _setAuthStartDate,
    setAuthEndDate: _setAuthEndDate,
    setPlacementType: _setPlacementType,
    setRelapse: _setRelapse,
    setAuthComment: _setAuthComment,
    setCompletionSurveyAdministered: _setCompletionSurveyAdministered,
    setAuthIsLocked: _setAuthIsLocked,
    setAdministrativeTransferAdmit: _setAdministrativeTransferAdmit,
    setAuthorizationReviewedBy: _setAuthorizationReviewedBy,
    setReviewDate: _setReviewDate,
    setAthTPRcd: _setAthTPRcd,
    setAth1502Rcd: _setAth1502Rcd
  },
  extraReducers: {
    [getAuthForm.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  newAuthForm,
  setModality,
  setCommunityBasedProvider,
  setBudgetType,
  setAuthType,
  setFundingOrg,
  setTransferForm,
  setInitialReferral,
  setAthIssueDate,
  setExt1IssueDate,
  setExt2IssueDate,
  setAuthorizedByOriginal,
  setAuthorizedByExtension1,
  setAuthorizedByExtension2,
  //setDaysAuthorisedStartDate,
  setExt1StartDate,
  setExt2StartDate,
  setDaysAuthorisedQty,
  setExt1DayQty,
  setExt2DayQty,
  setDaysAuthorisedDayDelay,
  //setDaysAuthorisedEndDate,
  setExt1EndDate,
  setExt2EndDate,
  setOverAllStartDate,
  setOverallQty,
  setOverAllEndDate,
  setUnitsTotal,
  setMaxUnitsPerWeek,
  setMaxIndsPerWeek,
  setMaxGrpsPerWeek,
  setCbpAdmitDate,
  setCbpDischargeDate,
  setAuthStartDate,
  setAuthEndDate,
  setPlacementType,
  setRelapse,
  setAuthComment,
  setCompletionSurveyAdministered,
  setAuthIsLocked,
  setAdministrativeTransferAdmit,
  setAuthorizationReviewedBy,
  setReviewDate,
  setAthTPRcd,
  setAth1502Rcd
} = authFormSlice.actions;

export default authFormSlice.reducer;
